var _module_exports = "<div class=\"bg-light lter b-b wrapper-md\">\n  <h1 class=\"m-n font-thin h3\">Dashboard</h1>\n  <small class=\"text-muted\">Quandoo Operation Center</small>\n</div>\n<div class=\"wrapper-md\" data-ng-include=\"'/app/common/dashboard/changelog.html'\"></div>\n";;
var path = '/app/common/dashboard/dashboard.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/dashboard/dashboard.html
// module id = 920
// module chunks = 0